import { render, staticRenderFns } from "./TaskSearch.vue?vue&type=template&id=4d4dcd44&scoped=true"
import script from "./TaskSearch.vue?vue&type=script&lang=js"
export * from "./TaskSearch.vue?vue&type=script&lang=js"
import style0 from "./TaskSearch.vue?vue&type=style&index=0&id=4d4dcd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4dcd44",
  null
  
)

export default component.exports